export default "__VITE_ASSET__7c94c2a9__"